<template>
	<b-modal ref="modal" title="Edit gift type" :busy="loading>0">
		<b-form @submit.stop.prevent="save(); return false" id="giftTypeEditForm">
			<b-form-row>
				<b-col>
					<b-form-group label="Service">
						<b-form-input plaintext v-model="curGiftType.service_name"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Gift type">
						<b-form-input plaintext v-model="curGiftType.name"></b-form-input>
					</b-form-group>
				</b-col>
			</b-form-row>
			<b-form-row>
				<b-col>
					<b-form-group label="Singular">
						<b-form-input v-model="curGiftType.string" placeholder="string"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Plural">
						<b-form-input v-model="curGiftType.string_multi" placeholder="string multi"></b-form-input>
					</b-form-group>
				</b-col>
			</b-form-row>
			<b-form-group label="Image">
				<pipi-pupu-file v-model="curGiftType.image" />
			</b-form-group>
			<b-form-group label="Image URL">
				<b-form-input readonly v-model="curGiftType.image_url" />
			</b-form-group>
			<b-form-group>
				<b-form-checkbox switch v-model="curGiftType.group">Group</b-form-checkbox>
			</b-form-group>
		</b-form>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<template #modal-footer="{cancel}">
			<b-spinner v-show="loading>0" small label="Loading"></b-spinner>
			<b-button size="sm" variant="success" type="submit" form="giftTypeEditForm">
				Save
			</b-button>
			<b-button size="sm" @click="cancel()">
				Cancel
			</b-button>
		</template>
	</b-modal>
</template>

<script>
import PipiPupuFile from '../../PipiPupuFile.vue';

export default {
	name: 'GiftTypeEditModal',
	components: {
		PipiPupuFile,
	},
	data() { return {
		protocols: [],
		fields: null,
		id: null,
		curGiftType: {settings: {}},
		loading: 0,
		error: null
	}},
	methods: {
		show(item) {
			this.error = null;
			this.curGiftType = {};
			this.loading++;
			this.$api.get(`giftType/${encodeURIComponent(item.service_id)}/${encodeURIComponent(item.gift_type)}`).then(giftType => {
				this.curGiftType = giftType;
			}).catch(err => this.error = err).finally(() => this.loading--);
			this.$refs.modal.show();
		},
		save() {
			this.error = null;
			this.loading++;
			this.$api.post(`giftType/${encodeURIComponent(this.curGiftType.service_id)}/${encodeURIComponent(this.curGiftType.gift_type)}`, {
				string: this.curGiftType.string,
				string_multi: this.curGiftType.string_multi,
				image_md5: this.curGiftType.image&&this.curGiftType.image.md5,
				group: this.curGiftType.group,
			}).then(() => {
				this.$refs.modal.hide();
				this.$bvToast.toast('Successfully saved', {
					title: 'Success',
					variant: 'success',
					solid: true
				});
				this.$emit('saved');
			}).catch(err => this.error = err).finally(() => this.loading--);
		},
	}
};
</script>
